/**
 *
 * @module subscriptionStatusSubType
 * @see https://github.com/STRML/keyMirror
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef SubscriptionStatusSubType
 * @type {Object}
 *
 * @property {String} PENDING_VOLUNTARY_CANCEL
 * @property {String} PENDING_INVOLUNTARY_CANCEL
 * @property {String} VOLUNTARY_CANCEL
 * @property {String} INVOLUNTARY_CANCEL
 * @property {String} LAPSED
 *
 */

/**
 *
 * @enum
 * @type {SubscriptionStatusSubType}
 *
 */
export default KeyMirror({
    /**
     *
     * @access public
     * @type {String}
     *
     */
    PENDING_VOLUNTARY_CANCEL: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    PENDING_INVOLUNTARY_CANCEL: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    VOLUNTARY_CANCEL: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    INVOLUNTARY_CANCEL: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    LAPSED: null
});



// WEBPACK FOOTER //
// ./src/services/subscription/subscriptionStatusSubType.js